<div id="editor" class="toto">
    <p>azert</p>
</div>